<template>
  <div>
    <div class="list">
      <swipe-cell v-for="(item, index) in list" :key="index">
        <div class="item-text">
          <div class="mag-text">{{ item.text }}</div>
        </div>
        <template #right>
          <div class="right-btn" v-if="item.uid != 0">
            <div class="edit" @click="editmsg(item)">
              <i class="iconfont icon-bianji"></i>
            </div>
            <div class="del" @click="delMsg(item)">
              <i class="iconfont icon-lajitong"></i>
            </div>
          </div>
        </template>
      </swipe-cell>
    </div>

    <div class="item-text add" @click="addNewMsg">
      <div class="mag-text">添加快捷短语</div>
    </div>
    <van-dialog v-model="show" show-cancel-button @confirm="addMsg">
      <div class="edit-text">
        <textarea
          name=""
          id=""
          cols="30"
          rows="10"
          placeholder="请输入快捷短语（限300字）"
          maxlength="300"
          v-model="userMsg"
        ></textarea>
      </div>
    </van-dialog>
  </div>
</template>

<script>
/**
@description:快捷短语
@createTime:2021-09-03
@create:wq
*/
import { SwipeCell, Dialog } from "vant";
export default {
  name: "",
  props: {},
  components: { SwipeCell, [Dialog.Component.name]: Dialog.Component },
  data() {
    return {
      show: false,
      list: [],
      userMsg: "",
      handleType: 0, //0-新增 1-编辑
      id:'',
      pageFrom:'',
      service:'',
      tid:'',
    };
  },
  computed: {},
  watch: {},
  mounted() {},
  created() {
    this.pageFrom = this.$route.query.t;//1-客服窗口进入的页面
    this.tid = this.$route.query.tid;//老师id
    if(localStorage.getItem('user')){
      let user = JSON.parse(localStorage.getItem('user'));
      this.service = user.service == 1 && this.pageFrom == 1 ? 1 : '';
    }
    this.shortcutsList();
  },

  // 在创建之前，添加body的style属性， 单独设置背景色
  beforeCreate() {
    document.querySelector("body").setAttribute("style", "background:#F6F6F6");
  },
  // 在销毁前，将body的style属性删除
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
  methods: {
    editmsg(item) {
      this.show = true;
      this.userMsg = item.text;
      this.id = item.id;
      this.handleType = "1";
    },
    addNewMsg() {
      this.show = true;
      this.userMsg = "";
      this.id = ''
      this.handleType = "0";
    },
    delMsg(item) {
      if (item.uid == 0) {
        this.Toast("系统短语不可删除");
        return;
      }
      Dialog.confirm({
        message: "确定删除该快捷短语？",
      })
        .then(() => {
          this.deleteMsg(item);
          // on confirm
        })
        .catch(() => {
          // on cancel
        });
    },
    shortcutsList() {
      this.api.shortcutsList({service:this.service,tid:this.tid}).then((res) => {
        this.list = res.data;
      });
    },
    deleteMsg(item) {
      this.api.shortcutsDel({ id: item.id  ,service:this.service}).then(() => {
        this.Toast.success("删除成功");
        this.shortcutsList();
      });
    },
    addMsg() {
      if (this.userMsg) {
        if (this.handleType == 1) {
          this.api.shortcutsAdd({ text: this.userMsg,id:this.id ,service:this.service,tid:this.tid}).then(() => {
            this.Toast.success("编辑成功");
            this.shortcutsList();
            this.show = false;
          });
        } else {
          this.api.shortcutsAdd({ text: this.userMsg  ,service:this.service,tid:this.tid}).then(() => {
            this.Toast.success("添加成功");
            this.shortcutsList();
            this.show = false;
          });
        }
      } else {
        this.Toast("请输入要添加的短语");
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.item-text {
  height: 0.88rem;
  display: flex;
  align-items: center;
  justify-content: center;
  border-bottom: 1px solid #f0f0f0;
  margin: 0 0.24rem;
  box-sizing: border-box;

  font-size: 0.3rem;
  font-weight: bold;
  color: #333333;
  .mag-text {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
}
.right-btn {
  display: flex;
  height: 100%;
}
.edit {
  background: #64b3f9;
  color: #ffffff;
  width: 1.2rem;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.del {
  background: #f9647d;
  color: #ffffff;
  width: 1.2rem;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.add {
  color: #4fd9d5;
  font-weight: bold;
}
.edit-text {
  width: 5.78rem;
  height: 2.76rem;
  background: #ffffff;
  opacity: 1;
  margin: 0 auto;
  padding: 0.44rem 0;
  textarea {
    border-radius: 5px;
    border: 1px solid #e6e6e6;
    width: 100%;
    height: 100%;
    border: none;
    outline: none;
    padding: 4px;
    box-sizing: border-box;
    resize: none;
    background: #f5f5f5;
  }
}
</style>
